import {OperatingAreaEntity} from "@ots-frontend/ots-data";
import {Card, Divider, Grid, Group, Text, Title} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {ObjectMappingDataTableCard} from "../../card/ObjectMappingDataTableCard/ObjectMappingDataTableCard";
import {HasAccess} from "../../auth/HasAccess/HasAccess";
import {DefaultText} from "../../text/DefaultText/DefaultText";

export type OperatingAreaDetailsProps = {
  operatingArea: OperatingAreaEntity
}

export const OperatingAreaDetails = (props: OperatingAreaDetailsProps) => {
  const {operatingArea} = props;

  const {t} = useTranslation(["common"]);

  return (
    <Grid>
      <Grid.Col span={6}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>

          <Group position="apart" pb="sm">
            <Title order={4}>{t("common.entity.operatingarea.profile.info.section.details.label", "Details")}</Title>
          </Group>

          <Divider/>

          <Grid>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.operatingarea.profile.info.field.name.label", "Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {operatingArea.name}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.operatingarea.profile.info.field.company.label", "Company")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {operatingArea.companyId && <DefaultText value={operatingArea.companyName}/>}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.operatingarea.profile.info.field.companyunit.label", "Company Unit")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {operatingArea.companyUnitId && <DefaultText value={operatingArea.companyUnitName}/>}
              </Text>
            </Grid.Col>
          </Grid>
        </Card>
      </Grid.Col>
      <Grid.Col span={6}>
        <HasAccess permissions={["objectmapping_view"]}>
          <ObjectMappingDataTableCard entity={operatingArea}/>
        </HasAccess>
      </Grid.Col>
    </Grid>
  );
};

